import * as React from "react";
import type { SVGProps } from "react";
const SvgClockPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m15 14.4-3.6-1.2V8.182M21 12a9.6 9.6 0 1 0-7.8 9.432m6-5.832v3m0 0v3m0-3h3m-3 0h-3"
    />
  </svg>
);
export default SvgClockPlus;
